// extracted by mini-css-extract-plugin
export default {"root":"Ecosystem_root__lkbgj"};